module.exports = __webpack_public_path__ + "images/2b2cca7073eb13c3c78d9e0508cd6368.svg";